import Vue from "vue";
import noty from "./noty.service";

export default {
    async getSettingsByClientAsync(clientId) {
        return (await Vue.http.get(`/api/aviatrix/settings/byclient/${clientId}`)).data;
    },
    async saveSettingsAsync(clientId, settings) {
        await Vue.http.post(`/api/aviatrix/settings/byclient/${clientId}`, settings);
        noty.success("Settings saved successfully");
    }
};


// WEBPACK FOOTER //
// ./src/services/aviatrix.service.js